import React, {Component} from 'react';
import AlertContainer from 'react-alert'

import FbWrapper from '../lib/FirebaseWrapper';
import SubmissionCard from '../components/SubmissionCard';
import NavigationBar from '../components/NavigationBar';
import Footer from '../components/Footer';
import FixedFooter from '../components/FixedFooter';

const styles = {
  container: {
    minHeight: '100%'
  },
  placeholder: {
    textAlign: 'center'
  },
  placeholderText: {
    color: 'black',
    lineHeight: 25,
    fontSize: 26
  },
  content: {
    maxWidth: '60%',
    marginLeft: '20%'
  },
}

export default class HistoryView extends Component {
  state = {
    submissions: []
  }

  renderNotFound() {
    return (
      <div style={styles.placeholder}>
        <a style={styles.placeholderText}>No result found!</a>
      </div>
    )
  }

  renderLoading() {
    return (
      <div style={styles.placeholder}>
        <a style={styles.placeholderText}>Loading...</a>
      </div>
    )
  }

  renderSubmissions() {
    return this.state.submissions.map(sub => (<SubmissionCard key={sub.key} data={sub}/>));
  }

  componentWillMount() {
    this.fetchSubmissionsByEmail(this.props.account);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchSubmissionsByEmail(nextProps.account);
  }

  fetchSubmissionsByEmail(value) {
    FbWrapper.fetchSubmissionsByEmail(
      (value || ""),
      (res) => {
        var vals = res.val() || {};
        var keys = Object.keys(vals);
        var submissions = keys.map(k => {
          return Object.assign(vals[k], {key: k});
        });
        if (submissions.length > 0) {
          this.setState({submissions: submissions.reverse()});
        } else {
          this.setState({submissions: []});
          this.msg.show("Email account not found!", {
            time: 2000,
            type: 'error',
            icon: <img src="http://i.imgur.com/C7RBc0g.png" alt="error" style={{width:32, height:32}} />
          });
        }
      }
    );
  }

  alertOptions = {
    offset: 14,
    position: 'bottom left',
    theme: 'light',
    time: 5000,
    transition: 'scale'
  }

  render() {
    let fixedFooter = () =>
      <FixedFooter/>
    let pageEndFooter = () =>
      <Footer/>

    return (
      <div style={styles.container}>
        <NavigationBar history={this.props.history} account={this.props.account}/>
        <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />

        <div style={styles.content}>
          <h3 style={{paddingTop: 50}}>Account: {this.props.account}</h3>
          {this.state.submissions === undefined ? this.renderLoading() : (this.state.submissions.length > 0 ? this.renderSubmissions() : this.renderNotFound())}
        </div>

        {this.state.submissions.length<1 ? fixedFooter() : pageEndFooter()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/HistoryView.js